module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/003-9c8ad4e65e60115dd97d7a726dbca567.jpg";